/* eslint-disable */
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 100px;
  padding: 32px;
`;

export const Title = styled.p`
  font-family: 'Roboto';
font-style: normal;
font-weight: 400;
font-size: 24px;
line-height: 123.5%;
letter-spacing: 0.25px;
color: rgba(0, 0, 0, 0.87);
`;

export const Description = styled.p`
font-family: 'Roboto';
font-style: normal;
font-weight: 400;
font-size: 14px;
line-height: 143%;
letter-spacing: 0.17px;
color: rgba(0, 0, 0, 0.6);
`;
